import React, { Component } from 'react'
import axios from 'axios'

class Verify extends Component {
  
  state = {
    isLoading: false,
    isSuccessful: false
  }

  componentDidMount() {
    if(this.props.match.params.user !== undefined && this.props.match.params.hash !== undefined) {
      this.setState({ isLoading: true })
      let url = process.env.REACT_APP_API_URL + '/users/' + this.props.match.params.user + '/tasks/verify/actions/' + this.props.match.params.hash
      axios.get(url)
      .then(response => {
        if (response.status === 200 && response.data.status === "active") {
          this.setState({ isLoading: false, isSuccessful: true })
        } else {
          this.setState({ isLoading: false, isSuccessful: false })
        }
      })
      .catch(error => {
        this.setState({ isLoading: false, isSuccessful: false })
      })
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = () => {
        return
    }
  }
  
  render() {
    return (
      <div class="d-flex flex-column flex-root">
        <div class="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid">
          <div class="login-content flex-row-fluid d-flex flex-column p-10">
            <div class="d-flex flex-row-fluid flex-center">
              <div class="login-form">
                <div class="pb-5 pb-lg-15">
                  <h4 class="text-muted font-weight-bold font-size-h4">Pivicon ID</h4>
                  <h3 class="font-weight-bolder text-dark font-size-h2 font-size-h1-lg">Registrierung</h3>
                  <h4 class="text-muted font-weight-bold font-size-h4 mt-5">
                    {this.state.isLoading ? <span class="spinner"></span> : this.state.isSuccessful ? "Registrierung erfolgreich bestätigt - Zugangsdaten siehe E-Mail." : <></> }
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Verify;